'use strict';

module.exports = {
	destinationLinks: [
		{title: 'SVT Play', url: '//www.svtplay.se'},
		{title: 'Barn\u00ADkanalen', url: '//www.svt.se/barnkanalen'},
		{title: 'Bolibompa', url: '//www.svt.se/barnkanalen/bolibompa'},
		{title: 'SVT Nyheter', url: '//www.svt.se/nyheter'},
		{title: 'SVT Sport', url: '//www.svt.se/sport'},
		{title: 'Öppet arkiv', url: '//www.oppetarkiv.se'}
	],
	infoPageLinks: [
		{title: 'Väder', url: '//www.svt.se/vader'},
		{title: 'TV-tablå', url: '//www.svt.se/tv-tabla/'},
		{title: 'Program A-Ö', url: '//www.svt.se/program/'}
	]
};



/** WEBPACK FOOTER **
 ** ./app/components/PageHandler/data/menuData.js
 **/